import type { Pagination, ProductAttribute } from '@barboxx/models/types';

import { api } from '../../api';

const rootPath = 'products/attributes';

export function getProductAttributes(query: ProductAttribute.SearchQuery) {
    return api.get<Pagination<ProductAttribute>>(rootPath, query);
}

export function getProductAttribute(id: number) {
    return api.get<ProductAttribute.DetailsResponse>(
        `${rootPath}/${id}`,
        undefined
    );
}

export function postProductAttribute(data: ProductAttribute.CreateRequest) {
    return api.post<ProductAttribute>(rootPath, data);
}

export function putProductAttribute(
    id: number,
    data: ProductAttribute.UpdateRequest
) {
    return api.put<ProductAttribute>(`${rootPath}/${id}`, data);
}

export function deleteProductAttribute({ id }: ProductAttribute.DeleteRequest) {
    return api.delete(`${rootPath}/${id}`, undefined);
}
